import { Box, Fade } from '@mui/material';
import { OfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';
import { OrderStatus } from '../../interfaces/order-status.interface';
import {
  ADD_PRODUCT_FADE_TRANSITION_DURATION,
  ADD_PRODUCT_ROW_BOTTOM_SPACING,
} from '../../orders.constants';
import { AddOrderProductMode } from '../orderProducts.types';
import AddOrderProductRow from './AddOrderProductRow/AddOrderProductRow';

interface AddOrderProductAreaProps {
  isOpen: boolean;
  orderId: string;
  orderStatus: OrderStatus | OfflineStatus;
  mode?: AddOrderProductMode;
  isFloating?: boolean;
}

const AddOrderProductArea = ({
  isOpen,
  orderId,
  orderStatus,
  mode,
  isFloating,
}: AddOrderProductAreaProps) => {
  return (
    <Fade
      in={isOpen}
      unmountOnExit
      timeout={{
        exit: 0,
        enter: ADD_PRODUCT_FADE_TRANSITION_DURATION,
      }}
    >
      <Box
        sx={{
          mb: ADD_PRODUCT_ROW_BOTTOM_SPACING,
          ...(isFloating && { position: 'absolute', top: 0, left: 0, right: 0 }),
        }}
      >
        <AddOrderProductRow orderId={orderId} orderStatus={orderStatus} mode={mode} />
      </Box>
    </Fade>
  );
};

export default AddOrderProductArea;
